/**
 * ¿Es una cuenta de BAC? Se decide por el nombre de la cuenta en BC ("BAC SAN JOSE COL. 933743908").
 * Solo las cuentas BAC generan archivo de banco (.prn de Sucursal Electrónica) y, por eso, tienen
 * consecutivo por proveedor. Las demás (BNCR, etc.) se pagan sin archivo de la app.
 */
export function esCuentaBAC(nombreCuenta) {
    return /\bBAC\b/i.test(nombreCuenta);
}
/** ¿Es una cuenta del Banco Nacional? También por el nombre de la cuenta en BC ("BNCR COL. 123"). */
export function esCuentaBNCR(nombreCuenta) {
    return /\b(BNCR|BN)\b/i.test(nombreCuenta);
}
/**
 * Código de banco dentro del IBAN costarricense (posiciones 5-8). Es lo que decide a qué banco
 * pertenece una cuenta: el campo de texto "banco" de Proveedores no sirve para eso (la importación
 * de referencias de BAC lo dejó en "BAC" hasta en cuentas del BN).
 */
export const CODIGO_BANCO_IBAN = { BAC: '0102', BN: '0151' };
/** Banco de un IBAN: BAC, BN u OTRO. `null` si no parece un IBAN de Costa Rica (CR + 20 dígitos). */
export function bancoDeIban(iban) {
    const limpio = (iban ?? '').replace(/[\s-]/g, '').toUpperCase();
    if (!/^CR\d{20}$/.test(limpio))
        return null;
    const codigo = limpio.slice(4, 8);
    if (codigo === CODIGO_BANCO_IBAN.BAC)
        return 'BAC';
    if (codigo === CODIGO_BANCO_IBAN.BN)
        return 'BN';
    return 'OTRO';
}
/** Código de banco (4 dígitos) de un IBAN de Costa Rica; `null` si no parece uno. */
export function codigoBancoDeIban(iban) {
    const limpio = (iban ?? '').replace(/[\s-]/g, '').toUpperCase();
    return /^CR\d{20}$/.test(limpio) ? limpio.slice(4, 8) : null;
}
/**
 * Entidades que reciben cuentas IBAN, según el listado de participantes del SINPE (Banco Central de
 * Costa Rica). El código es el de 4 dígitos que va en las posiciones 5-8 del IBAN (el BN es "0151").
 * BAC y BN llevan su sigla porque son los dos bancos por los que se paga.
 */
export const NOMBRE_BANCO_POR_CODIGO = {
    // Bancos
    '0100': 'Banco Central',
    '0102': 'BAC',
    '0104': 'Davivienda',
    '0107': 'BCT',
    '0114': 'Lafise',
    '0116': 'Promérica',
    '0120': 'Improsa',
    '0123': 'Davibank',
    '0125': 'Cathay',
    '0126': 'Banco General',
    '0127': 'Banco CMB (Citi)',
    '0151': 'BN',
    '0152': 'BCR',
    '0161': 'Banco Popular',
    '0162': 'BANHVI',
    '0231': 'Banco Internacional (BICSA)',
    // Mutuales
    '0803': 'Mutual Alajuela',
    '0804': 'Mutual Cartago',
    // Financieras
    '0304': 'Financiera Cafsa',
    '0310': 'Financiera MultiMoney',
    '0322': 'Financiera Comeca',
    '0326': 'Financiera Desyfin',
    '0329': 'Financiera Monge',
    // Asociaciones solidaristas
    '0205': 'ASECCSS',
    '0207': 'ASEBANACIO',
    // Cooperativas
    '0790': 'Coopeguanacaste',
    '0811': 'Coocique',
    '0812': 'Coope San Marcos',
    '0813': 'CoopeAlianza',
    '0814': 'Coopenae',
    '0816': 'Cooperativa de Servicios Públicos',
    '0817': 'Coope Ande N° 1',
    '0820': 'CoopeCaja',
    '0821': 'Caja de ANDE',
    '0822': 'Coopemep',
    '0824': 'Credecoop',
    '0825': 'Coopesanramón',
    '0827': 'Coopebanpo',
    '0830': 'Coopecar',
    '0831': 'Coopegrecia',
    '0832': 'Coopavegra',
    '0833': 'Coopeuna',
    '0840': 'Coopemédicos',
    '0842': 'Coopejudicial',
    '0845': 'Coopedetallistas',
    '0846': 'Coopefyl',
    '0847': 'CoopeAyA',
};
/** "BAC", "BN", "BCR"… o "Banco 0999" si el código no está en la tabla. `null` si no es un IBAN. */
export function nombreBancoDeIban(iban) {
    const codigo = codigoBancoDeIban(iban);
    if (!codigo)
        return null;
    return NOMBRE_BANCO_POR_CODIGO[codigo] ?? `Banco ${codigo}`;
}
/** Banco de una cuenta de ORIGEN de Business Central, por su nombre ("BAC SAN JOSE COL. …", "BNCR COL. …"). */
export function bancoDeCuentaBC(nombreCuenta) {
    if (esCuentaBAC(nombreCuenta))
        return 'BAC';
    if (esCuentaBNCR(nombreCuenta))
        return 'BN';
    return null;
}
//# sourceMappingURL=cuentaBAC.js.map